import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2, CircleAlert, X } from 'lucide-react';

const ToastContext = createContext(() => {});
export const useToast = () => useContext(ToastContext);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const show = useCallback((message, type = 'success') => {
    const id = crypto.randomUUID();
    setToasts((items) => [...items, { id, message, type }]);
    setTimeout(() => setToasts((items) => items.filter((item) => item.id !== id)), 4200);
  }, []);
  const value = useMemo(() => show, [show]);
  return <ToastContext.Provider value={value}>
    {children}
    <div className="toast-stack" aria-live="polite">
      <AnimatePresence>{toasts.map((toast) => <motion.div key={toast.id} className={`toast ${toast.type}`} initial={{ opacity: 0, y: 18, scale: .96 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, x: 30 }}>
        {toast.type === 'error' ? <CircleAlert size={18} /> : <CheckCircle2 size={18} />}
        <span>{toast.message}</span>
        <button onClick={() => setToasts((items) => items.filter((item) => item.id !== toast.id))} aria-label="Închide notificarea"><X size={16}/></button>
      </motion.div>)}</AnimatePresence>
    </div>
  </ToastContext.Provider>;
}
